module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c06-2966ef9ccceb33acbbc231dec6b22a15.jpg";